var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.666 24.167h26.667v2.666H.666v-2.666zM3.333 13.5h2.666v9.333H3.333V13.5zm6.666 0h2.667v9.333H9.999V13.5zm5.334 0h2.666v9.333h-2.666V13.5zm6.666 0h2.667v9.333h-2.667V13.5zM.666 6.833L13.999.167l13.334 6.666v5.334H.666V6.833zm2.667 1.648V9.5h21.333V8.481L13.999 3.148 3.333 8.481zm10.666-.314A1.333 1.333 0 1114 5.5a1.333 1.333 0 010 2.667z",
    fill: "#F8FAFF"
  })));
}
export default SvgWire;